import { render, staticRenderFns } from "./SatisSiparisleri.vue?vue&type=template&id=3235e28e&"
import script from "./SatisSiparisleri.vue?vue&type=script&lang=js&"
export * from "./SatisSiparisleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports